import {IndexFilters, type CheckboxGroupProps} from '../../IndexTemplate/components/IndexFilters/IndexFilters'
import type {Filters, SelectedFilters} from '../types'

// Helper to capitalize the first letter for display labels
const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

type AsideProps = {
  filters: Filters
  selectedFilters?: SelectedFilters
}

export const Aside = ({filters, selectedFilters = {}}: AsideProps) => {
  const checkboxGroups: CheckboxGroupProps[] = Object.entries(filters)
    .filter(([, concepts]) => concepts.length > 0)
    .map(([schemeId, concepts]) => {
      const selectedIds = selectedFilters[schemeId] || []
      return {
        value: schemeId,
        label: capitalize(schemeId),
        checkboxes: concepts.map(concept => ({
          label: concept.preferred_label,
          value: concept.id,
          isChecked: selectedIds.includes(concept.id),
        })),
      }
    })

  return <IndexFilters checkboxGroups={checkboxGroups} />
}
